module.exports = __webpack_public_path__ + "static/img/sm2.980f949.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm2.jpg
// module id = 9fIw
// module chunks = 1